import { StyledComponent } from '@emotion/styled';
import {
  styled,
  ToggleButtonGroup as MuiToggleButtonGroup,
  toggleButtonGroupClasses,
  ToggleButtonGroupProps,
} from '@mui/material';

export const ToggleButtonGroup: StyledComponent<ToggleButtonGroupProps> = styled(MuiToggleButtonGroup)(({ theme }) => ({
  [`& .${toggleButtonGroupClasses.grouped}`]: {
    border: 1,
    borderRadius: theme.shape.borderRadius,
    margin: theme.spacing(0.75),
    [`&.${toggleButtonGroupClasses.disabled}`]: {
      border: 0,
    },
  },
  [`& .${toggleButtonGroupClasses.firstButton},& .${toggleButtonGroupClasses.middleButton},& .${toggleButtonGroupClasses.lastButton}`]:
    {
      border: `1px solid transparent`,
      marginLeft: -1,
    },
}));
